import { createMuiTheme } from '@material-ui/core/styles';

// Create a theme instance.
const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#00675b'
    },
    secondary: {
      main: '#b0003a'
    },
    error: {
      main: '#ba000d'
    },
    warning: {
      main: '#c41c00'
    },
    info: {
      main: '#3f51b5'
    },
    success: {
      main: '#087f23'
    }
  },
  typography: {
    fontFamily: [
      "Montserrat", 
      "Noto Sans HK", 
      "Noto Sans TC",
      'Roboto',
       "Helvetica Neue", 
       "Helvetica",
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    fontSize: 16
  },
});

export default theme;